import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation, faBullhorn, faInfo } from '@fortawesome/free-solid-svg-icons';

const ShapeColor = styled.div`
    background-color: ${({ backgroundColor }) => backgroundColor};
    border: 1px solid ${({ borderColor }) => borderColor ?? ' #000'};
    width: 30px;
    text-align: center;
    border-radius: ${({ circle }) => (!!circle ? '20px' : '0px')};
`;

const UrgencyShapedIcon = ({ status, classNames, styles, useIcon, showNormalIcon, borderColor, circle }) => {
    let bgColor = '#fff';
    let iconColor = '#000';
    switch (status) {
        case 'Critical':
            bgColor = '#f80300';
            iconColor = '#fff';
            break;
        case 'High':
            bgColor = '#fcc200';
            iconColor = '#000';
            break;
        case 'Normal':
            bgColor = '#1f70b8';
            iconColor = '#fff';
            break;
    }
    return (
        <ShapeColor
            backgroundColor={bgColor}
            className={classNames}
            style={styles}
            borderColor={borderColor}
            circle={circle}
        >
            {useIcon && <UrgencyIcon status={status} showNormalIcon={showNormalIcon} color={iconColor} />}
        </ShapeColor>
    );
};

UrgencyShapedIcon.defaultProps = {
    status: 'Normal',
    classNames: '',
    styles: {},
    useIcon: true,
    showNormalIcon: false,
    circle: false,
};

export default UrgencyShapedIcon;

const UrgencyIcon = ({ status, color, showNormalIcon, size, classNames, styles }) => {
    let Icon = () => <></>;
    switch (status) {
        case 'Critical':
            Icon = () => (
                <FontAwesomeIcon className={classNames} style={styles} size={size} icon={faExclamation} color={color} />
            );
            break;
        case 'High':
            Icon = () => (
                <FontAwesomeIcon className={classNames} style={styles} size={size} icon={faBullhorn} color={color} />
            );
            break;
        case 'Normal':
            Icon = () =>
                showNormalIcon ? (
                    <FontAwesomeIcon className={classNames} style={styles} size={size} icon={faInfo} color={color} />
                ) : (
                    <></>
                );
            break;
    }
    return <Icon />;
};

UrgencyIcon.defaultProps = { status: 'Normal', showNormalIcon: false, classNames: '', styles: {} };

export { UrgencyIcon };
